export default function( string ) {
	const colors = {
		0: "grey lighten-5 text--black",
		1: "grey lighten-3 text--black",
		2: "grey lighten-4 text--black",
		3: "grey lighten-2 text--black",
		4: "grey lighten-1 text--black",
		5: "grey",
		6: "grey darken-1",
		7: "grey darken-2",
		8: "grey darken-3",
		9: "grey-darken-4",
		a: "red",
		b: "red darken-2",
		c: "pink",
		d: "pink darken-2",
		e: "purple",
		f: "purple darken-2",
		g: "deep-purple",
		h: "deep-purple darken-2",
		i: "indigo",
		j: "indigo darken-2",
		k: "blue",
		l: "blue darken-2",
		m: "teal",
		n: "teal darken-2",
		o: "green",
		p: "green darken-2",
		q: "light-green",
		r: "light-green darken-2",
		s: "amber darken-1",
		t: "amber darken-3",
		u: "orange",
		v: "orange darken-3",
		w: "deep-orange",
		x: "deep-orange darken-2",
		y: "blue-grey",
		z: "blue-grey darken-2"
	};

	if ( !string ) {
		return null;
	}

	return colors[string.slice( 0, 1 ).toLowerCase()];
}
